export const NUMBER_OF_HELP_CENTERS_PER_FETCH = 10;

export const SORT_ORDER = 'CREATED_DATE_ASCENDING';

export const CHARACTER_LIMIT_MULTI_HC_DROPDOWN_ITEMS = 21;
